export const CROP_ASPECT_RATIO = {
  fullWidth: 21 / 9,
  pageWidth: 16 / 9,
};
